import React from 'react';
import Index from './pages/Index';
import Create from './pages/Create';
import Edit from './pages/Edit';
import { AppRouteProps } from '~/routes';

export default function EthnicityRoutes(): readonly AppRouteProps[] {
  const routes: AppRouteProps[] = [
    {path: '/ethnicity', component: Index, isProtected: true, permissions: ['ethnicity_index']},
    {path: '/ethnicity/create', component: Create, isProtected: true, permissions: ['ethnicity_create']},
    {path: '/ethnicity/edit/:id', component: Edit, isProtected: true, permissions: ['ethnicity_edit']},

  ];

  return routes;
}
